import { createContext, useContext, useEffect, useState } from "react";
import { getData } from "../utils/api-service";

export const TranslationContext = createContext();

export const TranslationProvider = (props) => {
    const [currentLanguage, changeLanguage] = useState("en_NA");
    const [translation, setTranslations] = useState({});

    const translate = (t) => translation ? translation[t] : t;

    useEffect(() => {
        getData(`/translations/${props.translationFile}/${currentLanguage}.json`)
            .then(data => setTranslations(data))
    }, [currentLanguage]);


    return <TranslationContext.Provider value={{ changeLanguage, translate }} >
        {props.children}
    </TranslationContext.Provider>
}

export const withTranslation = (Component) => {
    return function WithTranslation(props) {
        return <TranslationContext.Consumer>
            {(translation) => <Component {...props} translation={translation} />}
        </TranslationContext.Consumer>
    };
}

export const useTranslation = () => useContext(TranslationContext)